module.exports = __webpack_public_path__ + "img/ywcj-jjfa_zhjjfa.52e2a6f0.png";